export enum CompetenciaStatusEnum {
    ANALISE = 'ANALISE',
    REPROVADA = 'REPROVADA',
    APROVADA = 'APROVADA'
}
